export default {
    "html" : require("./html").default,
    "js": require("./js").default,
    "minJs": require("./minJs").default,
    "css": require('./css').default,
    "cssMobile": require('./cssMobile').default,
    "scss": require('./scss').default,
    "scssMobile": require('./scssMobile').default,
}